<template>
  <div>
    <div class="data-table-title">
      <div class="data-table-description">DMで頻繁に利用する言い回しや回答を事前に作成しておくことで、スムーズにメッセージのやり取りを行えます。</div>
      <el-button type="success" icon="el-icon-plus" @click="openPhrase()">新規作成</el-button>
    </div>
    <div class="data-table-message" :class="header_notification ? 'header-notification-space-120' : ''">
      <!-- <div class="data-table-message-title">タイトル</div> -->
      <listColumn :column="'title'" :css="'phrase-title'" :title="'タイトル'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
      <div class="data-table-message-content">メッセージ</div>
      <memberBrandSelect style="padding:0 10px" :type="'client'" :target_client="target_client" @selectClient="selectClient" />
      <memberBrandSelect style="padding:0 10px" :type="'member'" :member="member" @selectMember="selectMember" />
      <listColumn :column="'created_at'" :css="'80'" :title="'作成日'" :sort_key="sort_key" :sort_order="sort_order" @sortBy="sortBy" />
      <div class="data-table-th-90">管理</div>
    </div>
    <div class="data-table-th-loading" v-loading="loading" v-if="loading"></div>
    <div class="data-table-list-nolist" v-if="phrase_list.length == 0 && !loading">
      <img src="../../assets/chat_image.png" style="opacity:0.5" alt />
      <div style="font-size:20px; font-weight:700; margin-bottom:15px;">テンプレートがありません</div>
      <div class="data-table-list-nolist-content">テンプレートを作成すると、ワンクリックでDMを送付できるようになります。</div>
      <el-button type="success" @click="phrase_drawer = true" icon="el-icon-plus">新規テンプレート作成</el-button>
    </div>
    <div v-if="!loading">
      <div v-for="(phrase, phrase_index) in phrase_list" v-bind:key="phrase.id" class="data-table-list-tr">
        <div class="data-table-list-phrase-title">
          <span style="color:#000; font-weight:600">{{ phrase.phrase_title }}</span>
        </div>
        <div class="data-table-message-content">{{ phrase.phrase_content }}</div>
        <brandDropdown :id="phrase.phrase_id" :list="phrase" :target_client="target_client" :index="phrase_index" @changeTargetClient="changeTargetClient" @deleteClient="deleteClient" />
        <memberDropdown :id="phrase.phrase_id" :list="phrase" :index="phrase_index" @addMember="addMember" @deleteMember="deleteMember" />
        <div class="data-table-list-80">
          <span style="color:#666; font-weight:400">{{ phrase.created_at | dateYMD }}</span>
        </div>
        <div class="data-table-list-manage">
          <el-tooltip placement="top">
            <div slot="content">テンプレートを編集</div>
            <el-button type="default" size="small" style="padding: 9px 10px" @click="editPhrase(phrase)">
              <i class="el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">テンプレートを削除</div>
            <el-button type="default" size="small" style="padding: 9px 10px" @click="deletePhrase(phrase.phrase_title, phrase.phrase_id, phrase_index)">
              <i class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </div>

    <!-- テンプレート作成 -->
    <transition name="fade">
      <phraseDrawer v-if="phrase_drawer" :phrase_drawer="phrase_drawer" :phrase_info="phrase_info" :phrase_type="phrase_type" @closePhrase="closePhrase()" @loadPhrase="loadPhrase()" />
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadPhraseAPI = root + "/api/message/load_phrase";
const deletePhraseAPI = root + "/api/message/delete_phrase";
const loadMemberAPI = root + "/api/member/load_member";
const editPhraseAPI = root + "/api/message/edit_phrase";
import phraseDrawer from "./phrase_drawer.vue";
import memberBrandSelect from "../list/list_select_member";
import brandDropdown from "../list/list_dropdown_brand";
import memberDropdown from "../list/list_dropdown_member";
import listColumn from "../list/list_column";

export default {
  name: "phrase",
  components: {
    phraseDrawer,
    memberBrandSelect,
    brandDropdown,
    memberDropdown,
    listColumn,
  },
  data() {
    return {
      phrase_drawer: false,
      phrase_list: [],
      phrase_info: [],
      phrase_type: "",
      target_client: [],
      member: [],
      requestId: 0,
      loading: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    textarea_rows() {
      var num = this.chat_value.split("\n").length;
      return num > 8 ? 9 : num > 1 ? num : 1;
    },
    textarea_height() {
      return this.textarea_rows * 16;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    sessionid() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.sessionid;
      } else {
        return null;
      }
    },
    csrftoken() {
      if (this.$store.state.ig_selected) {
        return this.$store.state.ig_selected.csrftoken;
      } else {
        return null;
      }
    },
    client_select() {
      return this.$store.state.client_select;
    },
    member_select() {
      return this.$store.state.member_select;
    },
    sort_key() {
      return this.$store.state.phrase_sort_key;
    },
    sort_order() {
      return this.$store.state.phrase_sort_order;
    },
  },
  mounted() {
    this.loadPhrase(true);
    this.loadMember();
  },
  methods: {
    loadPhrase(loading) {
      if (loading) this.loading = true;
      this.axios
        .get(loadPhraseAPI, {
          params: {
            token: this.token,
            user_token: this.user_token,
            sort_order: this.sort_order,
            sort_key: this.sort_key,
            person_id: this.member_select.person_id,
            target_client_id: this.client_select.target_client_id,
          },
        })
        .then((response) => {
          this.phrase_list = response.data.phrase_list;
          setTimeout(() => {
            this.loading = false;
          }, 300);
        });
    },
    sortBy(sort_key) {
      if (this.sort_key != sort_key) {
        var sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          sort_order = "desc";
        } else if (this.sort_order == "asc") {
          sort_order = "desc";
        } else {
          sort_order = "asc";
        }
      }
      this.$store.dispatch("phraseSort", { sort_key, sort_order });
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    openPhrase() {
      this.phrase_info = [];
      this.phrase_type = "create";
      this.phrase_drawer = true;
    },
    closePhrase() {
      this.phrase_drawer = false;
    },
    editPhrase(phrase) {
      this.phrase_info = phrase;
      this.phrase_type = "edit";
      this.phrase_drawer = true;
    },
    deletePhrase(phrase_title, phrase_id, phrase_index) {
      const h = this.$createElement;
      this.$msgbox({
        title: "テンプレート削除",
        type: "warning",
        message: h("p", null, [h("span", null, "テンプレート「" + phrase_title + "」を削除しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
        showCancelButton: true,
        confirmButtonClass: "danger",
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
      }).then(() => {
        var params = new URLSearchParams();
        params.append("phrase_id", phrase_id);
        params.append("token", this.token);
        this.axios.post(deletePhraseAPI, params).then((response) => {
          if (response.data.status == "OK") {
            this.phrase_list[phrase_index].length = [];
            this.loadPhrase();
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "テンプレート「" + phrase_title + "」を削除しました",
            });
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: "テンプレート「" + phrase_title + "」の削除に失敗しました",
            });
          }
        });
      });
    },
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          this.member = response.data.member;
          this.target_client = response.data.target_client;
        });
    },
    selectMember(member) {
      this.$store.dispatch("selectMember", member);
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    selectClient(client) {
      this.$store.dispatch("selectClient", client);
      this.phrase_list = [];
      this.loadPhrase(true);
    },
    changeTargetClient(target_client_id, phrase_id) {
      var params = new URLSearchParams();
      params.append("phrase_id", phrase_id);
      params.append("target_client_id", target_client_id);
      params.append("edit_type", "change_brand");
      params.append("token", this.token);
      this.axios.post(editPhraseAPI, params).then(() => {
        this.loadPhrase(false);
      });
    },
    deleteClient(target_client_id, phrase_id, phrase_index) {
      var params = new URLSearchParams();
      params.append("phrase_id", phrase_id);
      params.append("edit_type", "delete_brand");
      params.append("token", this.token);
      this.axios.post(editPhraseAPI, params).then(() => {
        this.phrase_list[phrase_index].target_client_id = null;
        this.phrase_list[phrase_index].target_client_name = null;
        if (target_client_id == this.client_select.target_client_id) this.phrase_list.splice(phrase_index, 1);
      });
    },
    addMember(person_id, member_index, phrase_id, phrase_index) {
      var params = new URLSearchParams();
      params.append("phrase_id", phrase_id);
      params.append("person_id", person_id);
      params.append("edit_type", "add_member");
      params.append("token", this.token);
      this.axios.post(editPhraseAPI, params).then(() => {
        this.phrase_list[phrase_index].member_count += 1;
        this.phrase_list[phrase_index].member[member_index].assign = true;
        this.phrase_list[phrase_index][person_id] = true;
      });
    },
    deleteMember(person_id, member_index, phrase_id, phrase_index) {
      var params = new URLSearchParams();
      params.append("phrase_id", phrase_id);
      params.append("person_id", person_id);
      params.append("edit_type", "delete_member");
      params.append("token", this.token);
      this.axios.post(editPhraseAPI, params).then(() => {
        this.phrase_list[phrase_index].member_count -= 1;
        this.phrase_list[phrase_index].member[member_index].assign = false;
        this.phrase_list[phrase_index][person_id] = false;
        if (person_id == this.member_select.person_id) this.phrase_list.splice(phrase_index, 1);
      });
    },
  },
  watch: {},
  filters: {
    dateYMD(val) {
      var date = new Date(val);
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate();
      if (Y!="1970") return Y + "/" + M + "/" + D;
      else return "-"
    },
  },
};
</script>
